import styled from 'styled-components'
import AntdDivider from 'antd/lib/divider'
import { WHITE, GRAY, GRAY_DARK } from '../../../theme/colors'
import Switch from 'antd/lib/switch'

export const OptionsContainer = styled.div`
  display: flex;
  align-items: center;
  margin-left: 10px;
`

export const Options = styled.div`
  margin-right: 12px;
  border: ${({ disabled }: OptionsProps) => (disabled ? `1px solid ${GRAY_DARK}` : `1px solid #a9a9a9`)};
  border-radius: 4px;
  padding: 0px 10px;
`

interface OptionsProps {
  withMargin?: boolean
  disabled?: boolean
  active?: boolean
}

export const OptionButton = styled.div`
  width: 27px;
  user-select: none;
  height: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: ${({ disabled }: OptionsProps) =>
    disabled ? 'not-allowed' : 'pointer'};
  margin: ${({ withMargin }: OptionsProps) =>
    withMargin ? '16px 0px' : '0px'};
`

export const GuideButton = styled(Switch)`
  background: #A8A0A1;
  margin: 2px 22px 5px 6px;
  &.ant-switch-checked {
    background: #34C759;
  }
`

export const ToolTipText = styled.div`
  text-align: center;
`

export const ControlIcon = styled.img`
  padding: 4px;
  width: 23px;
  filter: ${({ active }: OptionsProps) =>
    active ? 'invert(60%)' : 'unset'};
`

export const Divider = styled(AntdDivider)`
  margin: 0px;
  user-select: none;
`

export const ClearPlaceholderIcon = styled.img`
  width: 30px;
`

export const OptionName = styled.p`
  font-size: 10px;
  color: ${({ disabled }: OptionsProps) => (disabled ? GRAY : WHITE)};
  margin: 0;
  padding: 0 5px;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/DesignCenterCustomize/OptionsControllerV1/styledComponents.tsx